import { RANKS, SUITS, type Card } from "./types";

/**
 * Construction et melange du paquet de 52 cartes. Le melange est deterministe
 * par graine (mulberry32, meme generateur que les textures procedurales du
 * studio) : une meme graine redonne exactement la meme donne — c'est ce qui
 * permet "Rejouer la meme donne" et, plus tard, des defis quotidiens partages.
 */

export function mulberry32(seed: number): () => number {
  let a = seed;
  return () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Les 52 cartes, face cachee, dans l'ordre canonique (par enseigne puis par rang). */
export function buildDeck(): Card[] {
  const deck: Card[] = [];
  for (const suit of SUITS) {
    for (const rank of RANKS) {
      deck.push({ suit, rank, faceUp: false });
    }
  }
  return deck;
}

/** Melange de Fisher-Yates deterministe par graine (ne modifie pas l'entree). */
export function shuffle(deck: readonly Card[], seed: number): Card[] {
  const rng = mulberry32(seed);
  const result = deck.map((card) => ({ ...card }));
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    const a = result[i]!;
    result[i] = result[j]!;
    result[j] = a;
  }
  return result;
}

/** Graine aleatoire pour une nouvelle donne (entier 32 bits non signe, jamais 0). */
export function randomSeed(): number {
  return Math.max(1, Math.floor(Math.random() * 0xffffffff));
}
